import { useConfig } from "../contexts/ConfigContext"
import { contentPath, modules } from "../config/pages"
import React, { useEffect, useState } from "react"
import { CalendarOutlined, HomeOutlined, BarChartOutlined, TeamOutlined } from "@ant-design/icons"
import { useHistory } from "react-router-dom"
import { ItemType } from "antd/es/menu/interface"
import { useUser } from "../contexts/UserContext"
import { SideBar as SharedSideBar } from "@ryo/ui"

const menuOptions = [
  {key: modules.Home, label:"Inicio", icon: <HomeOutlined />},
  {key: modules.Calendar, label:"Calendario", icon: <CalendarOutlined />},
  {key: modules.Tracking, label:"Seguimiento", icon: <BarChartOutlined />},
  {key: modules.Contacts, label:"Contactos", icon: <TeamOutlined />},
]

function getMenuItems(permissions:any){
  const views = permissions?.views || []
  const availableOptions = menuOptions.filter(el => {
    return views.join().toLowerCase().includes(el.key.toLowerCase())
  })
  return availableOptions.length > 0 ? availableOptions : [menuOptions[0]]
}

const getParentKey = (key: string,menuItems:ItemType[]) => {
  const parent = menuItems.find(item => 
    item && "children" in item && Array.isArray((item as any).children) &&
    (item as any).children.some((child: any) => child.key === key)
  );
  return parent?.key?.toString() ?? null;
};

function SideBar(props:any){
  const history = useHistory()
  const {config,updateConfig} = useConfig()
  const {user} = useUser()
  const menuItems = React.useMemo(() => getMenuItems(user.permissions), [user.permissions]);
  const [openKey, setOpenKey] = useState<string | null>(getParentKey(config.module,menuItems)); 
  
  useEffect(() => {
    setOpenKey(getParentKey(config.module,menuItems)); 
  }, [config.module, menuItems]);

  const handleOpenChange = (keys: string[]) => {
    setOpenKey(keys.at(-1) ?? null);
  };
  
  const toggleCollapsed = () => {
    updateConfig({sideCollapsed:!config.sideCollapsed})
  };

  const handleSelected = (key: string) => {
    const moduleSelectedKey = Object.keys(modules).find(k => modules[k as keyof typeof modules] === key) as keyof typeof modules
    const module = modules[moduleSelectedKey]
    updateConfig({module});
    history.push(contentPath[module])
  }

  return(
    <SharedSideBar 
      activeKey={config.module}
      collapsed={config.sideCollapsed}
      isMobile={config.isMobile}
      menuItems={menuItems}
      openKey={openKey}
      onToggle={toggleCollapsed}
      onSelect={handleSelected}
      onOpenChange={handleOpenChange}
      title="Ryo Calendar"
      logoSrc="/assets/icons/calendar-sidebar.png"
    />
  )
}

export default SideBar